import { useWidgetInnerSize } from './useWidgetInnerSize.js';

export const useGridRequiredHeight = ({
  gridRef,
  widgetRef,
  theme,
  setTargetHeight
}) => {
  const dimensions = useWidgetInnerSize(widgetRef, theme);

  const setRequiredGridHeight = () => {
    const api = gridRef.current?.api;
    const container = widgetRef.current;

    if (!api || !container) {
      setTargetHeight(0);
      return;
    };

    const rowHeight = api.getDisplayedRowAtIndex(0)?.rowHeight || 42;
    const rowsHeight = api.getDisplayedRowCount() * rowHeight;

    const headerHeight = container.querySelector('.ag-header')?.getBoundingClientRect().height || 0;
    const currentHeight = container.getBoundingClientRect().height;
    const widgetHeaderHeight = dimensions?.header || 0;

    setTargetHeight(Math.max(rowsHeight + headerHeight + widgetHeaderHeight + 1, currentHeight + widgetHeaderHeight));
  };

  return {
    setRequiredGridHeight
  };
};
